var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import CloseIcon from "@bookingcom/bui-assets-react/streamline/CloseIcon";
import Button from "../Button/index.js";
import styles from "@bookingcom/bui-core/css/DismissibleContainer.module.css";
var DismissibleContainer = function (props) {
    var hideClose = props.hideClose, children = props.children, fill = props.fill, onClose = props.onClose, buttonColor = props.buttonColor, className = props.className, attributes = props.attributes, closeAriaLabel = props.closeAriaLabel, closeClassName = props.closeClassName, closeAttributes = props.closeAttributes;
    var rootClassNames = classNames(styles.root, className, fill && styles["root--fill"], hideClose && styles["root--hide-close"]);
    var closeClassNames = classNames(styles.close, closeClassName);
    var handleClose = function () { return onClose && onClose(); };
    return (React.createElement("div", __assign({}, attributes, { className: rootClassNames }),
        children,
        !hideClose && (React.createElement(Button.Aligner, { alignment: ["top", "end"], className: closeClassNames },
            React.createElement(Button, { variant: buttonColor === "inherit"
                    ? "tertiary-inherit"
                    : "tertiary-neutral", onClick: handleClose, attributes: __assign(__assign({}, closeAttributes), { "aria-label": closeAriaLabel }), icon: CloseIcon })))));
};
export default DismissibleContainer;
